import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './content-list4.css'

const ContentList4 = (props) => {
  return (
    <div className="content-list4-container thq-section-padding">
      <div className="content-list4-max-width thq-section-max-width thq-flex-column">
        <div className="content-list4-content3 thq-flex-column">
          <ul className="content-list4-ul1 thq-flex-column">
            <li className="content-list4-li1 list-item thq-flex-column">
              <h2>
                {props.heading7 ?? (
                  <Fragment>
                    <h2 className="content-list4-text10 thq-heading-2">
                      <span>Who We Are</span>
                      <br></br>
                    </h2>
                  </Fragment>
                )}
              </h2>
              <p>
                {props.content7 ?? (
                  <Fragment>
                    <p className="content-list4-text19 thq-body-small" style={{ textAlign: 'justify', display: 'block' }}>
                      The Commonwealth Artificial Intelligence Consortium (CAIC)
                      is a transformative initiative under the Commonwealth
                      Secretariat&apos;s Strategic Plan 2021-2025, aimed at
                      harnessing artificial intelligence (AI) to foster
                      sustainable development across Commonwealth countries.
                      CAIC focuses on small states and vulnerable economies,
                      providing a supportive ecosystem for AI adoption to drive
                      economic growth, sustainability, and employment
                      generation. CAIC aims to provide leadership, governance,
                      advocacy, advisory services, and a technology ecosystem
                      for the safe, inclusive, and sustainable advancement of
                      Commonwealth nations. AI&apos;s potential to contribute
                      significantly to the global economy is recognized, with
                      projections suggesting it could add up to $15.7 trillion
                      by 2030, driven by increased productivity and
                      consumption-side effects.
                    </p>
                  </Fragment>
                )}
              </p>
            </li>
          </ul>
          <img
            alt={props.imageAlt}
            src={props.imageSrc}
            className="content-list4-image"
          />
        </div>
        <div className="content-list4-content4 thq-flex-column">
          <ul className="content-list4-ul2 thq-flex-column">
            <li className="content-list4-li2 list-item thq-flex-column">
              <h2>
                {props.heading1 ?? (
                  <Fragment>
                    <h2 className="content-list4-text28 thq-heading-2">
                      About the Commonwealth AI Consortium
                    </h2>
                  </Fragment>
                )}
              </h2>
              <p>
                {props.content1 ?? (
                  <Fragment>
                    <p className="content-list4-text20 thq-body-small">
                      <span>
                        CAIC is committed to ensuring inclusive access for all,
                        eliminating discrimination in cyberspace, and adopting
                        online safety policies for all users, especially
                        children, whilst upholding human rights.
                      </span>
                      <br></br>
                    </p>
                  </Fragment>
                )}
              </p>
              <ul className="content-list4-ul3 thq-flex-column" style={{ listStyleType: 'none', padding: 0 }}>
                <li className="list-item">
                  <h3>
                    {props.heading2 ?? (
                      <Fragment>
                        <h3 className="content-list4-text14 thq-heading-3">
                          The Plan
                        </h3>
                      </Fragment>
                    )}
                  </h3>
                  <p>
                    {props.content2 ?? (
                      <Fragment>
                        <p className="content-list4-text13 thq-body-small">
                          The CAIC’s broad objective is to provide leadership,
                          governance, advocacy and advisory services on the
                          entire AI ecosystem for the Commonwealth Small States
                          to adopt transformative and AI-driven technologies for
                          the safe, inclusive and sustainable advancement of the
                          members.
                        </p>
                      </Fragment>
                    )}
                  </p>
                </li>
                <li className="list-item">
                  <h3>
                    {props.heading5 ?? (
                      <Fragment>
                        <h3 className="content-list4-text15 thq-heading-3">
                          <span>Governance of CAIC</span>
                          <br></br>
                        </h3>
                      </Fragment>
                    )}
                  </h3>
                  <p>
                    {props.content5 ?? (
                      <Fragment>
                        <p className="content-list4-text24 thq-body-small">
                          <span>
                            The CAIC is governed by a Steering Committee chaired
                            by Rwanda, with representation from the private
                            sector, think tanks, and member states.
                          </span>
                          <br></br>
                          <span>
                            Its work is carried out through four working groups:
                            Research and Innovation, Capacity Building, Data and
                            Infrastructure, and Policies.
                          </span>
                        </p>
                      </Fragment>
                    )}
                  </p>
                </li>
                <li className="list-item">
                  <h3>
                    {props.heading6 ?? (
                      <Fragment>
                        <h3 className="content-list4-text18 thq-heading-3">
                          Champion countries
                        </h3>
                      </Fragment>
                    )}
                  </h3>
                  <h4 className="lead-country-title">Lead Country:</h4> 
                  <span className="country-name">Rwanda 🇷🇼</span>
                  <p>
                    {props.content6 ?? (
                      <Fragment>
                        <p className="content-list4-text23 thq-body-small">
                          <div className="countries-grid">
                            <div className="country-column">
                              <div className="country-item">Bangladesh 🇧🇩</div>
                              <div className="country-item">Bahamas 🇧🇸</div>
                              <div className="country-item">The Gambia 🇬🇲</div>
                              <div className="country-item">Antigua and Barbuda 🇦🇬</div>
                            </div>
                            <div className="country-column">
                              <div className="country-item">Trinidad and Tobago 🇹🇹</div>
                              <div className="country-item">Mauritius 🇲🇺</div>
                              <div className="country-item">Malta 🇲🇹</div>
                              <div className="country-item">Seychelles 🇸🇨</div>
                            </div>
                            <div className="country-column">
                              <div className="country-item">Sri Lanka 🇱🇰</div>
                              <div className="country-item">Fiji 🇫🇯</div>
                              <div className="country-item">Togo 🇹🇬</div>
                            </div>
                          </div>
                        </p>
                      </Fragment>
                    )}
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="content-list4-content8 thq-flex-column">
          <ul className="content-list4-ul4 thq-flex-column"></ul>
        </div>
      </div>
    </div>
  )
}

ContentList4.defaultProps = {
  heading7: undefined,
  imageAlt: 'image',
  content2: undefined,
  heading2: undefined,
  heading5: undefined,
  heading6: undefined,
  content7: undefined,
  content1: undefined,
  content6: undefined,
  imageSrc: '/image-99.png',
  content5: undefined,
  heading1: undefined,
}

ContentList4.propTypes = {
  heading7: PropTypes.element,
  imageAlt: PropTypes.string,
  content2: PropTypes.element,
  heading2: PropTypes.element,
  heading5: PropTypes.element,
  heading6: PropTypes.element,
  content7: PropTypes.element,
  content1: PropTypes.element,
  content6: PropTypes.element,
  imageSrc: PropTypes.string,
  content5: PropTypes.element,
  heading1: PropTypes.element,
}

export default ContentList4
